export default {
      id: "arrow-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#arrow",
      toString: function () {
        return this.url;
      }
    }